import { useState, useEffect } from "react";
import { CircularProgress, MenuItem, Select } from "@mui/material";
import styles from "./EndUser/EndUser.module.css";
import MarketPlaceT1 from "./EndUser/MarketPlaceT1";
import MarketPlaceT2 from "./EndUser/MarketPlaceT2";
import MarketPlaceT3 from "./EndUser/MarketPlaceT3";
import { toast } from "react-toastify";

function EndUser({ skuId }) {
  const [paymentStatus, setPaymentStatus] = useState("IN");
  const [planType, setPlanType] = useState([]);
  const [selected, setSelected] = useState(0);
  const [intervals, setIntervals] = useState([]);
  const [selectInterval, setSelectedInterval] = useState(0);
  const [fetchLoader, setFetchLoader] = useState(false);
  const [plans, setPlans] = useState([]);
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    if (!skuId) return;
    try {
      async function fetchData() {
        setFetchLoader(true);
        const res = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/admin/end_user_view`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              skuId,
              currentRegion: paymentStatus === "IN" ? 1 : 0,
            }),
          },
        );
        const data = await res.json();
        setFetchLoader(false);
        if (data?.status === 200) {
          setPlanType(data.planType);
          setIntervals(
            data.intervals.map((int, index) => ({
              ...int,
              index,
            })),
          );
          setPlans(data.plans);
          setFeatures(data.features);
        } else {
          toast.info(data?.msg);
        }
      }
      fetchData();
    } catch (error) {
      console.log("Error", error);
      toast.error("Something went wrong");
    }
    // eslint-disable-next-line
  }, [skuId, paymentStatus]);

  useEffect(() => {
    const first = intervals.find((i) => i.typeId === selected);
    setSelectedInterval(first ? first.index : null);
  }, [selected, intervals]);

  const filteredFeaturesData = features.filter((f) => f.typeId === selected);
  const filteredAppsData = plans.filter(
    (p) => p.typeId === selected && p.interval === selectInterval,
  );

  return (
    <div className="flex flex-col justify-center items-center text-center w-[calc(100%-4rem)] md:w-[calc(100%-16rem)] !px-4 md:!px-10 pb-10 mt-[6rem] md:mt-[9rem] place-self-end">
      {/* Back Button */}
      <div className="w-full">
        <div className="w-full">
          <Select
            value={paymentStatus}
            onChange={(e) => setPaymentStatus(e.target.value)}
            displayEmpty
            sx={{ width: "25%" }}
          >
            <MenuItem value="IN">India View</MenuItem>
            <MenuItem value="US">US View</MenuItem>
          </Select>
          {fetchLoader && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <CircularProgress size={25} style={{ color: "blue" }} />
            </div>
          )}
          {!fetchLoader && (
            <div>
              <div className={styles.T1Container}>
                {plans.length > 0 && (
                  <>
                    <div className={styles.Plan_intervalContainer}>
                      <ul className={styles.productpricefilter}>
                        {planType.map((plan, i) => (
                          <li
                            key={i}
                            onClick={() => setSelected(i)}
                            className={`${styles.pricefilterbtn} ${
                              selected === i ? styles.selectedPlanType : ""
                            }`}
                          >
                            {plan.name}
                          </li>
                        ))}
                      </ul>
                      <div className={styles.intervalContainer}>
                        <ul className={styles.intervalUL}>
                          {intervals
                            .map((interval, index) => ({
                              ...interval,
                              index,
                            }))
                            .filter((int) => int.typeId === selected)
                            .map((interval) => (
                              <li
                                key={interval.index}
                                className={`${styles.intervals} ${
                                  selectInterval === interval.index
                                    ? styles.selectedPlanType
                                    : ""
                                }`}
                                onClick={() =>
                                  setSelectedInterval(interval.index)
                                }
                              >
                                {interval.n_interval} {interval.interval}
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                    <div className={styles.horizontalForm}>
                      {planType[selected]?.template === "recurring" && (
                        <MarketPlaceT1
                          selected={selected}
                          selectInterval={selectInterval}
                          plans={filteredAppsData}
                          features={filteredFeaturesData}
                        />
                      )}
                      {planType[selected]?.template === "credit" && (
                        <MarketPlaceT2
                          selected={selected}
                          selectInterval={selectInterval}
                          plans={filteredAppsData}
                          features={filteredFeaturesData}
                        />
                      )}
                      {planType[selected]?.template === "one_time" && (
                        <MarketPlaceT3
                          selected={selected}
                          selectInterval={selectInterval}
                          plans={filteredAppsData}
                          features={filteredFeaturesData}
                        />
                      )}
                    </div>
                  </>
                )}
                {plans.length === 0 && <div className="w-full">No Data</div>}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EndUser;
